import { Col } from "react-bootstrap";


export const ProjectCard = ({ title, description, imgUrl }) => {
return (
    <Col sm={6} md={4}>
        <div className="proj-imgbx">
            {/* To Do: add alt text to img tag */}
            <img src={imgUrl} alt=""/>
            <div className="proj-txtx">
                <h4>{title}</h4>
                <span>{description}</span>
            </div>
        </div>
    </Col>
)
}